module.exports = __webpack_public_path__ + "img/video_1.f7c05245.jpg";